import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'atom-ldg-img',
    imports: [CommonModule],
    templateUrl: './ldg-img.component.html',
    styleUrl: './ldg-img.component.css',
})
export class LdgImgComponent implements OnInit {
  // @Input('src') src: string | undefined;
  @Input('inputClass') inputClass: string | undefined;
  @Input('h') imageHeight: string | undefined;
  @Input('w') imageWidth: string | undefined;
  @Input('radius') imageRadius: string | undefined;

  @Input('aspect') aspect: string | undefined;
  @Input('fit') fit: string | undefined = "cover"
  /**
   * Shown instead of the stock placeholder when there is no image or it fails to load,
   * e.g. a creator's initials. Leave unset to keep the placeholder.
   */
  @Input('fallbackText') fallbackText: string | undefined;

  private _src?: string;
  @Input() set src(value: string | undefined) {
    this._src = value;
    this.isLoading = !!value;
    this.loadError = undefined;
  }
  get src() { return this._src; }
  isLoading: boolean | undefined;
  loadError: string | undefined;

  ngOnInit(): void {
    this.initComponent();
  }

  initComponent() {
    this.isLoading = true;
    this.loadError = undefined;
  }

  hideLoader() {
    this.isLoading = false;
    if (!this.loadError) {

    }
  }

  showError(event: any) {
    this.isLoading = false;
    this.loadError = JSON.stringify(event);
  }

  getDimensions() {
    let imageClass: string = '';
    if (this.imageHeight && this.imageWidth) {
      imageClass = `h-${this.imageHeight} w-${this.imageWidth}`;
    } else if (this.imageHeight) {
      imageClass = `h-${this.imageHeight} w-auto`;
    } else if (this.imageWidth) {
      imageClass = `w-${this.imageWidth} h-full`;
      imageClass = `w-${this.imageWidth}`;
    } else {
      imageClass = 'h-full w-full object-cover';
    }

    if (this.imageRadius) {
      imageClass = `${imageClass} rounded-${this.imageRadius}`;
    }

    if (this.fit) {
      imageClass = `${imageClass} object-${this.fit}`;
    }

    if (this.aspect) {
      imageClass = `${imageClass} ${this.aspect}`
    }

    return imageClass;
  }

  getAspect() {
    if (this.aspect) {
      return this.aspect
    }
    // return "aspect-h-16 aspect-w-16"
    return "aspect-square"
  }
}
